import { useReducer } from "react";
import axios from "axios";
import { getBasePath } from "../../Helpers/getEnvVar";
import { getAuthToken } from "../../Helpers/localStorage";

const loginAsHookInitialState = {
  isFetching: false,
  isSuccessful: false,
  errorMessage: "",
  result: {},
};

const loginAsHookReducer = (state, action) => {
  switch (action.type) {
    case "fetching":
      return {
        ...state,
        isFetching: true,
        isSuccessful: false,
        errorMessage: "",
        result: {},
      };
    case "success":
      return {
        ...state,
        isFetching: false,
        isSuccessful: true,
        result: { ...action.payload },
      };
    case "error":
      return {
        ...state,
        isFetching: false,
        isSuccessful: false,
        errorMessage: action.payload,
      };
    default:
      throw new Error("Unsupported Action");
  }
};

const useLoginAs = () => {
  const [userAs, dispatch] = useReducer(loginAsHookReducer, loginAsHookInitialState);
  const basePath = getBasePath();

  const setUser = ({ userId }) => {
    const token = getAuthToken();
    axios({
      url: `${basePath}/login-as?userId=${userId}`,
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((data) => {
        const userData = data?.data?.data;
        dispatch({
          type: "success",
          payload: userData,
        });
      })
      .catch((err) => {
        dispatch({ type: "error", payload: err?.response?.data?.error });
      });
  };

  const loginUser = (payload) => {
    dispatch({ type: "fetching" });
    setUser(payload);
  };

  return [userAs, loginUser];
};

export default useLoginAs;
